import BookIds from 'a/hub/data/BookIds';
import { logRumAction } from 'lib/DDRum';
import { showStandardErrorPage } from 'a/components/GlobalErrorHandler/actions';

import goToActivity from 'a/actions/navigationActions';
import { setGameLaunchedFrom } from 'a/hub/actions/metaGameActions';
import { setQuestBookMastered } from 'a/hub/actions/gameLevelProgressActions';
import gameIds from 'a/hub/data/GameIds';
import { setStatus, exitBook } from 'a/eReader/redux/actions/reader';
import BOOK_STATUS from 'a/eReader/data/book_status';

import { READING_ACTION_TYPES } from './action_types';
import createAction from './action_creator';
import { REDUX_ACTIONS, SCREENS } from '../../data/constants';
import { reportLevelComplete, reportExitBook } from './reporting';

/**
 * changes the main view of a game.
 * @param {string} screen - name of the view
 */
export const changeScreen = screen => createAction(REDUX_ACTIONS.CHANGE_SCREEN, screen);

export const openEreader =
  ({ gameLaunchedFrom, navigationParams, params = {}, isQuestWorkflow = false, bookInfo = {} }) =>
    (dispatch) => {
      const { bookGameId, chapter, isPractice } = bookInfo;

      if (!Object.values(BookIds).includes(bookGameId)) {
        dispatch(showStandardErrorPage('Error', `incorrect bookGameId: ${bookGameId}`));
        return;
      }

      const bookId = bookGameId.replace('ereader.', '');

      dispatch({
        type: READING_ACTION_TYPES.UPDATE_GAME_DETAILS,
        payload: {
          bookId,
          chapter,
          isPractice,
        },
      });
      dispatch(
        goToActivity({
          activityName: gameIds.E_READER,
          navigationParams,
          params,
          isQuestWorkflow,
        }),
      );
      dispatch(setGameLaunchedFrom(gameLaunchedFrom));
    };

/**
 * Completes a book once the student has achieved mastery or attempted it twice.
 * Persists the COMPLETE status with an immediate, awaited save, then reports the
 * level/round complete, records progress against the quest,
 * and exits the book (showing the loading screen while navigating).
 * If the save fails after retries, the global error screen is shown
 * instead of navigating.
 * @returns {Promise<void>}
 */
export const completeBook = () => async (dispatch, getState) => {
  const state = getState();
  const { bookInfo: { bookId, attempts, currentChapterId } } = state.eReader;
  const isMastered = true;
  const gameId = `ereader.${bookId}`;

  logRumAction('completeBook', { bookId, attempts, currentChapterId });

  try {
    await dispatch(setStatus(bookId, BOOK_STATUS.COMPLETE, null));
    dispatch(reportLevelComplete(isMastered));
    dispatch(reportExitBook(false, isMastered));

    dispatch(setQuestBookMastered(gameId));

    dispatch(changeScreen(SCREENS.LOADING));
    dispatch(exitBook());
  } catch (error) {
    dispatch(showStandardErrorPage('BOOK_STATUS_UPDATE_ERROR', 'Failed to complete a book'));
  }
};

/**
 * Dev-only shortcut: shows the loading screen, then completes the current book
 * as mastered and exits it.
 */
export const devCompleteBook = () => (dispatch) => {
  dispatch(changeScreen(SCREENS.LOADING));
  dispatch(completeBook());
};
